import { Injectable } from '@angular/core';
import { EnveloppeProduit, Habilitation, NatureOperation } from '@lib/models/generated/graphql';
import { gql } from 'apollo-angular';
import { QueryManagerService } from 'finzzle-angular-utils';
import { BehaviorSubject, firstValueFrom } from 'rxjs';

const FETCH_REFERENTIEL_DATA = gql`
  query fetchReferentielData {
    habilitations {
      id
      libelle
    }
    enveloppeProduits {
      code
      libelle
    }
    natureOperations {
      id
      libelle
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ReferentielService {
  habilitations? = new BehaviorSubject<Habilitation[] | undefined>(undefined);
  enveloppes? = new BehaviorSubject<EnveloppeProduit[] | undefined>(undefined);
  naturesOperations? = new BehaviorSubject<NatureOperation[] | undefined>(undefined);
  constructor(private queryManager: QueryManagerService) {}


  async getEnveloppes() {
    if (!this.enveloppes?.getValue()) {
      await this.fetchReferentielData();
    }
    return this.enveloppes?.getValue();
  }

  async getNaturesOperations() {
    if (!this.naturesOperations?.getValue()) {
      await this.fetchReferentielData();
    }
    return this.naturesOperations?.getValue();
  }

  private async fetchReferentielData() {
    let result = await firstValueFrom(
      this.queryManager.query<{
        habilitations: Habilitation[];
        enveloppeProduits: EnveloppeProduit[];
        natureOperations: NatureOperation[];
      }>({
        query: FETCH_REFERENTIEL_DATA,
      })
    );
    this.habilitations?.next(result?.data?.habilitations);
    this.enveloppes?.next(result?.data?.enveloppeProduits);
    this.naturesOperations?.next(result?.data?.natureOperations);
  }
}
